export const SECOND_IN_MILLISECONDS = 1000;
export const MINUTE_IN_MILLISECONDS = SECOND_IN_MILLISECONDS * 60;
export const HOUR_IN_MILLISECONDS = MINUTE_IN_MILLISECONDS * 60;
export const DAY_IN_MILLISECONDS = HOUR_IN_MILLISECONDS * 24;

export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_WITH_TIME = 'MM/DD/YYYY h:mm A';

export const SHORT_DATE = 'MMM D';
export const SHORT_TIME = 'h:mm A';
